import { syncDemoSessionFromLocation } from './previewMode';
import { installPreviewTransport } from './previewTransport';

syncDemoSessionFromLocation();
installPreviewTransport();
